import { Component } from '@angular/core';
@Component({
  selector: 'app-notification',
  standalone: false,
  templateUrl: './notification.component.html',
})
export class NotificationComponent {
  isOpen = false;

  togglePanel() {
    this.isOpen = !this.isOpen;
  }

  closePanel() {
    this.isOpen = false;
  }
}
